import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import styles from './index.module.scss';

const BACKGROUND_CSS_TRANSITION_TIMEOUT = 1000;

type PopupBackgroundType = {
	background:
		| {
				color?: string;
				opacity?: number;
		  }
		| undefined;
	isBackground: boolean;
};

export function PopupBackground({
	background,
	isBackground,
}: PopupBackgroundType) {
	const [opacity, setOpacity] = useState<number | undefined>(0);
	const { opacity: backgroundOpacity, color } = {
		opacity: 0,
		color: 'transparent',
		...background,
	};

	useEffect(() => {
		const opacityInDecimal = backgroundOpacity / 100;
		const newOpacity = isBackground ? opacityInDecimal : 0;
		const isSameOpacity = opacity === newOpacity;

		if (!isSameOpacity) {
			setOpacity(newOpacity);
		}
	}, [isBackground, opacity]);

	return (
		<CSSTransition
			timeout={BACKGROUND_CSS_TRANSITION_TIMEOUT}
			in={isBackground}
			classNames={{
				exit: styles.hidden,
			}}
			unmountOnExit
		>
			<div
				className={styles.popupBackground}
				style={{
					background: color,
					opacity,
				}}
			/>
		</CSSTransition>
	);
}
